import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import type { Matcher } from "./BmGridData";

export const stringMatcher: Matcher = (itemValue: any, search: string) => {
  return (
    itemValue &&
    itemValue.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
  );
};

export const dateMatcher: Matcher = (itemValue: any, search: string) => {
  return (
    itemValue &&
    tenantService
      .formatDate(itemValue)
      .toLowerCase()
      .indexOf(search.toLowerCase()) !== -1
  );
};
